import { FC } from 'react';
import { Outlet } from 'react-router-dom';
import { useAppContext } from '../App/App.hooks';
import { ErrorBoundary } from '../ErrorBoundary/ErrorBoundary';
import { LayoutWithSidebar, RouteOutlet } from './AppRoutes.style';
import { Sidebar } from './Components/Sidebar/Sidebar';
import { TopBar } from './Components/TopBar/TopBar';

export const SidebarLayout: FC = () => {
    const { isSidebarCollapsed } = useAppContext();

    return (
        <LayoutWithSidebar collapsed={isSidebarCollapsed}>
            <TopBar hasSidebar />
            <Sidebar />
            <ErrorBoundary>
                <RouteOutlet>
                    <Outlet />
                </RouteOutlet>
            </ErrorBoundary>
        </LayoutWithSidebar>
    );
};
